module.exports = __webpack_public_path__ + "media/fonts/aileron-thin-b38fd291.ttf";